import React, { useState, useEffect } from "react";

// Renders a connector's brand icon. Tries the catalog logo (Clearbit), then the
// site favicon (Google) — derived from the same domain — and finally falls back
// to a colored square with initials. This way the cards always show a real icon
// even when the logo CDN is unavailable.
const candidatesFor = icon => {
  if (!icon) return [];
  const m = icon.match(/clearbit\.com\/([^/?]+)/);
  // favicon first (reliable); the original logo URL as a secondary try
  const out = m ? [`https://www.google.com/s2/favicons?domain=${m[1]}&sz=128`] : [];
  out.push(icon);
  return out;
};

const ConnectorIcon = ({ icon, name, color, size = 44 }) => {
  const candidates = candidatesFor(icon);
  const [idx, setIdx] = useState(0);

  useEffect(() => setIdx(0), [icon]);

  const initials = (name || "?").trim().slice(0, 2).toUpperCase();
  const src = candidates[idx];

  if (src) {
    return (
      <img
        src={src}
        alt={name}
        width={size}
        height={size}
        onError={() => setIdx(i => i + 1)}
        style={{
          borderRadius: 10,
          objectFit: "contain",
          background: "#fff",
          border: "1px solid #ECECEC",
          padding: 4,
          boxSizing: "border-box",
          flexShrink: 0,
        }}
      />
    );
  }
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: 10,
        background: color || "#5F5E5A",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 700,
        fontSize: size * 0.36,
        flexShrink: 0,
      }}
    >
      {initials}
    </div>
  );
};

export default ConnectorIcon;
